import React from 'react';
import { useNavigate } from 'react-router-dom';

export function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h1 style={{ color: '#f05a5a' }}>403 — Unauthorized</h1>
      <p>You do not have permission to access this page.</p>
      <div style={{ marginTop: 16 }}>
        <button onClick={() => navigate(-1)} style={{ marginRight: 8 }}>Go Back</button>
        <button onClick={() => navigate('/dashboard')}>Go to Dashboard</button>
      </div>
    </div>
  );
}

export default Unauthorized;
